'use client';

import '@ui5/webcomponents/dist/ComboBoxItem.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `ComboBoxItem` represents the item for a `ComboBox`.
 *
 * __Note__: This is a UI5 Web Component! [Repository](https://github.com/SAP/ui5-webcomponents) | [Documentation](https://sap.github.io/ui5-webcomponents/)
 */
const ComboBoxItem = withWebComponent('ui5-cb-item', ['additionalText', 'text'], [], [], []);
ComboBoxItem.displayName = 'ComboBoxItem';
export { ComboBoxItem };